import React from 'react';
import {TextField} from '@mui/material';
import styles from './SearchBar.module.css';

const SearchBar = ({ searchQuery, onSearchChange }) => {
    return (
        <div>
            <TextField
                variant="outlined"
                placeholder="Search..."
                value={searchQuery}
                onChange={onSearchChange}
                color= "other"
                className={styles.searchInput}
            />
        </div>
    );
};

export default SearchBar;
